import { render, staticRenderFns } from "./RiskSurveyConstruction.vue?vue&type=template&id=23424564&"
import script from "./RiskSurveyConstruction.vue?vue&type=script&lang=js&"
export * from "./RiskSurveyConstruction.vue?vue&type=script&lang=js&"
import style0 from "./RiskSurveyConstruction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports